import { jsx as _jsx } from "react/jsx-runtime";
import { BLACK_900, Loader, TRANSPARENT, useBreakpoint, getTestId } from '@airtel/air-design-system';
export var StatusCardLoaderSection = props => {
  var _props$color = props.color,
    color = _props$color === void 0 ? BLACK_900 : _props$color,
    size = props.size,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? TRANSPARENT : _props$backgroundColo,
    testID = props.testID;
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var sizeWithBreakpoints = isLargeScreen ? 'xxl' : 'xl';
  return _jsx(Loader, Object.assign({}, getTestId(testID, 'loader'), {
    bgColor: backgroundColor,
    color: color,
    size: size || sizeWithBreakpoints
  }));
};